import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-check-in-alerts-modal',
  templateUrl: './check-in-alerts-modal.component.html',
  styleUrls: ['./check-in-alerts-modal.component.css']
})
export class CheckInAlertsModalComponent implements OnInit {

  @Input() alerts: string[];
  @Input() checkInAnywayCallback: () => undefined;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
  }

}
